// hooks/useploSixTableFilters.ts
import { useState, useEffect } from 'react';

export function usePloSixTableFilters() {
  const [searchTerm, setSearchTerm] = useState('');
  const [courtSearch, setCourtSearch] = useState('');
  const [partySearch, setPartySearch] = useState('');
  const [sectionSearch, setSectionSearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  const [debouncedCourt, setDebouncedCourt] = useState(courtSearch);
  const [debouncedParty, setDebouncedParty] = useState(partySearch);
  const [debouncedSection, setDebouncedSection] = useState(sectionSearch);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setDebouncedCourt(courtSearch);
      setDebouncedParty(partySearch);
      setDebouncedSection(sectionSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, courtSearch, partySearch, sectionSearch]);

  const handleClearFilters = () => {
    setSearchTerm('');
    setCourtSearch('');
    setPartySearch('');
    setSectionSearch('');
    setSelectedStatus('');
    setSelectedDate('');
    setCurrentPage(1);
  };

  const hasActiveFilters = Boolean(
    searchTerm ||
      courtSearch ||
      partySearch ||
      sectionSearch ||
      selectedStatus ||
      selectedDate
  );

  return {
    searchTerm,
    setSearchTerm,
    courtSearch,
    setCourtSearch,
    partySearch,
    setPartySearch,
    sectionSearch,
    setSectionSearch,
    selectedStatus,
    setSelectedStatus,
    selectedDate,
    setSelectedDate,
    currentPage,
    setCurrentPage,
    debouncedSearch,
    debouncedCourt,
    debouncedParty,
    debouncedSection,
    handleClearFilters,
    hasActiveFilters,
  };
}